export default __webpack_public_path__ + "static/media/focus-on-cores-tablet.d31d137b.png";